import { useAuthorization } from "@/hooks/use-authorization";
import Page403 from "./403";

interface Props {
  permissions: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  canHaveSomePermissions?: boolean;
}

const RoleGuard = ({
  permissions,
  fallback,
  children,
  canHaveSomePermissions = false,
}: Props) => {
  const { hasPermission } = useAuthorization();

  if (canHaveSomePermissions) {
    if (
      permissions.some((p) => {
        return hasPermission(p);
      }) ||
      permissions.length === 0
    ) {
      return <>{children}</>;
    }
    return <>{fallback ? fallback : <Page403 />}</>;
  }

  if (
    permissions.every((p) => {
      return hasPermission(p);
    }) ||
    permissions.length === 0
  ) {
    return <>{children}</>;
  }
  return <>{fallback ? fallback : <Page403 />}</>;
};

export default RoleGuard;
